import { useQuery } from '@tanstack/react-query'
import { profile, isDateTimePast, isEmpty } from '@myap/ui-library'
import { getRequest, queryIsEnabled } from '../utils/fetchOperations'
import { DEADLINES_KEY } from '../components/_common/reactquery'

const useDeadlinesQuery = ({ educationPeriodCd, educationPeriodsComplete }) => {
  const { apiUrl } = profile()
  return useQuery({
    queryKey: [DEADLINES_KEY, educationPeriodCd],
    enabled: queryIsEnabled(educationPeriodsComplete && !isEmpty(educationPeriodCd)),
    staleTime: 3600000,
    refetchOnWindowFocus: false,
    queryFn: async ({ signal }) => {
      const deadlinesData = await getRequest({
        url: `${apiUrl}/settings/order-deadlines`,
        params: { educationPeriodCd },
        signal,
      })
      const { deadlines } = deadlinesData
      const obj = {}
      Object.keys(deadlines).forEach(key => (obj[`${key}IsPast`] = isDateTimePast(deadlines[key])))

      return { ...deadlines, ...obj }
    },
  })
}

export default useDeadlinesQuery
